import { gql } from 'apollo-angular';
import { eventCardItemFragment } from '../event-card/event-card.fragments';
import { goalCardItemFragment } from '../goal-card/goal-card.fragments';
import { workspaceUserItemFragment } from '../user/user.fragments';

export const viewerWithCustomSettingsQuery = gql`
  query WorkspaceViewerWithCustomSettingsQuery {
    viewer {
      id
      customSettings
    }
  }
`;

export const ViewerHasPortfolioApplicationQuery = gql`
  query WorkspaceViewerHasPortfolioApplication {
    viewer {
      id
      hasPortfolioApplication
    }
  }
`;

export const ViewerWithProgramRolesQuery = gql`
  query WorkspaceViewerWithProgramRolesQuery($programRoleFilter: ProgramRoleFilter) {
    viewer {
      id
      isAdmin

      programRoles(filter: $programRoleFilter) {
        nodes {
          id
          name
          shortName
          roleType

          program {
            id

            organization {
              id
              ancestors {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const ViewerQuery = gql`
  query WorkspaceViewerQuery {
    viewer {
      ...WorkspaceUserItem
    }
  }
  ${workspaceUserItemFragment}
`;

export const ViewerWithCardsAndTasksQuery = gql`
  query WorkspaceViewerWithCardsAndTasksQuery {
    viewer {
      id

      cards {
        nodes {
          ... on GoalCard {
            ...GoalCardItemFragment

            workspace {
              id
              title
            }
          }

          ... on EventCard {
            ...EventCardItemFragment

            workspace {
              id
              title
            }
          }
        }
      }

      cardTasks {
        nodes {
          ... on CardTask {
            id
            title
            cardTaskStatus

            endDate

            card {
              ... on GoalCard {
                ...GoalCardItemFragment

                workspace {
                  id
                  title
                }
              }

              ... on EventCard {
                ...EventCardItemFragment

                workspace {
                  id
                  title
                }
              }
            }
          }
        }
      }
    }
  }

  ${goalCardItemFragment}
  ${eventCardItemFragment}
`;
